module.exports = __webpack_public_path__ + "img/jingxuan.faa3f8fb.png";